var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.706,
    height: 14.68,
    viewBox: "0 0 14.706 14.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gym",
    d: "M14.054,4.2,12.718,2.865l.58-.58a.613.613,0,1,0-.866-.866l-.58.58L10.514.662a2.267,2.267,0,0,0-3.127,0,2.211,2.211,0,0,0,0,3.128L8.723,5.127,5.113,8.738,3.775,7.4a2.267,2.267,0,0,0-3.127,0,2.211,2.211,0,0,0,0,3.128l1.337,1.337-.58.58a.613.613,0,1,0,.866.866l.58-.58,1.337,1.337a2.211,2.211,0,0,0,3.127-3.127L5.979,9.6,9.593,5.993,10.93,7.33A2.211,2.211,0,0,0,14.057,4.2Zm-7.316,8.3a.98.98,0,0,1-.289.7,1.009,1.009,0,0,1-1.395,0l-3.54-3.54A.986.986,0,1,1,2.909,8.267l3.54,3.54a.98.98,0,0,1,.289.7Zm6.449-6.041a1.009,1.009,0,0,1-1.395,0l-3.54-3.54A.986.986,0,1,1,9.648,1.529l3.54,3.54a.986.986,0,0,1,0,1.395Z",
    transform: "translate(0 -0.037)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.cf349edf49f3fd14077a59770670915f.svg";
export { ForwardRef as ReactComponent };